import * as actions from '../constants/card_action_types.jsx';
import * as api from '../constants/cards_api.jsx';
import { request_helper } from "./request_helper.js";

export const actionCards = {
    getCards: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_CARDS_LIST_API;

        let postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: filter.modelFilter,
            sortFilter: filter.sortFilter
        }
        
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            let cards = {
                items: data.items,
                filter: {
                    pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                    modelFilter: filter.modelFilter,
                    sortFilter: filter.sortFilter
                }
            }
            dispatch({ type: actions.GET_CARDS, cards });
        }
        catch (error){
            dispatch({ type: actions.END_REQUEST });
        }
    },
    addCard: (newCard, ownProps) => async (dispatch, getState) => {
        const url = api.ADD_CARD_API;
        try {
            const card = await request_helper.callWithDispatch(dispatch, "POST", url, newCard);
            dispatch({ type: actions.ADD_CARD, card });
            ownProps.history.goBack();
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    },
    editCard: (editCard, ownProps) => async (dispatch, getState) => {
        const url = api.EDIT_CARD_API;
        try {
            const card = await request_helper.callWithDispatch(dispatch, "POST", url, editCard);
            dispatch({ type: actions.EDIT_CARD, card });
            ownProps.history.goBack();
        }
        catch (error) {
            dispatch({ type: actions.END_REQUEST });
        }
    }
};
